<template>
    <div class="days-container">
        <button
            :class="`day-btn btn btn-secondary ${selectedDays.includes(day.value) ? 'selected-day' : ''}`"
            v-for="day of days"
            :key="day.value"
            @click="handleDaySelect(day.value)"
        >
            {{ day.name }}
        </button>
    </div>
</template>

<style lang="scss">
.day-btn {
    background-color: #b3b3b3 !important;
    color: #fff;
    font-weight: 800 !important;
    font-size: 0.9rem !important;
    margin-right: 0.1rem;
    padding: 0.3rem 0 !important;
    width: 2rem;
    text-align: center;
    border: none !important;
}

.selected-day {
    background-color: #2f79cd !important;
}
</style>

<script lang="ts" src="./DayPicker"></script>
